<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onCreate">
    <v-card tile>
      <v-card-title class="grey lighten-2">
        Skapa tåg avvikelse
      </v-card-title>

      <v-card-text class="mt-2">
        <TrainDeviationActivitySearch />
        <v-row>
          <TrainDeviationDeviationTypeField />
        </v-row>
        <TrainDeviationDepartureFields />
        <TrainDeviationArrivalFields />
        <TrainDeviationError v-if="isErrorArrivalBeforeDeparture">
          Ankomsttiden får inte vara innan avgångstiden!
        </TrainDeviationError>

        <TrainDeviationError v-if="isErrorSamePlaces">
          Ankomstplatsen får ej vara samma som avgångsplatsen!
        </TrainDeviationError>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer />
        <v-btn rounded @click="closeModal">Avbryt</v-btn>
        <v-btn rounded type="submit" color="primary" :loading="createPending">
          Skapa tåg avvikelse
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import gql from 'graphql-tag'
import { sync } from 'vuex-pathify'
import { required } from '@/common/validationRules'
import TrainDeviationActivitySearch from './TrainDeviationForm/TrainDeviationActivitySearch'
import TrainDeviationDeviationTypeField from './TrainDeviationForm/TrainDeviationDeviationTypeField'
import TrainDeviationDepartureFields from './TrainDeviationForm/TrainDeviationDepartureFields'
import TrainDeviationArrivalFields from './TrainDeviationForm/TrainDeviationArrivalFields'
import TrainDeviationError from './TrainDeviationForm/TrainDeviationError'

export default {
  name: 'TrainDeviationCreateModal',

  components: {
    TrainDeviationActivitySearch,
    TrainDeviationArrivalFields,
    TrainDeviationDepartureFields,
    TrainDeviationDeviationTypeField,
    TrainDeviationError
  },

  data: () => ({
    required,
    valid: true,
    createPending: false
  }),

  created() {
    this.$store.set(
      'trainDeviation/model@event_uuid',
      this.$store.get('event/selectedUUID')
    )
  },

  computed: {
    model: sync('trainDeviation/model'),

    isErrorArrivalBeforeDeparture() {
      return (
        new Date(this.model.arrival).getTime() <
        new Date(this.model.departure).getTime()
      )
    },

    isErrorSamePlaces() {
      return (
        this.model.from &&
        this.model.to &&
        this.model.from === this.model.to &&
        new Date(this.model.arrival).getTime() ===
          new Date(this.model.departure).getTime()
      )
    }
  },

  methods: {
    async onCreate() {
      const isValidForm = await this.$refs.form.validate()
      if (!isValidForm || this.isError) return
      this.createPending = true

      const model = {
        ...this.model,
        from: this.model.from.split('_')[0],
        to: this.model.to.split('_')[0]
      }

      await this.$apollo.mutate({
        mutation: gql`
          mutation($payload: CreateTrainDeviationInput!) {
            createTrainDeviation(payload: $payload) {
              train_deviation_uuid
            }
          }
        `,
        variables: {
          payload: {
            ...model,
            checked: true
          }
        }
      })

      this.createPending = false
      this.$store.commit('trainDeviation/create', {
        ...model,
        checked: true
      })
      this.closeModal()
    },

    closeModal() {
      this.$store.commit('trainDeviation/resetModel')
      this.$store.set('trainDeviation/places', [])
      this.$emit('close')
    }
  }
}
</script>
